import mustache from 'mustache';
import { campCardPlaceholder, folderIconTemplate } from "../util/mustache_templates";
import { addCampToFolder, createFolder, deleteFolder, getCampsInFolder, remCampFromFolder } from './general_util';
import { send_favoriteCamp, send_unfavoriteCamp } from './user_api';
// require('jqueryui/jquery-ui');
import 'jqueryui/jquery-ui';

export function remCampFromFolder_favoritesPage(remCampIconEl:HTMLElement) {
	let camp:number = parseInt($(remCampIconEl).attr("id"));
	let folder:number = parseInt($(remCampIconEl).attr("folder_id"));

	remCampFromFolder(camp,folder).then(() => {
		let folderCountEl:JQuery<HTMLElement> = $(`.folder-count[folder_id='${folder}']`);

		let folderCount:number = parseInt(folderCountEl.html());
		folderCount--;
		folderCountEl.html(folderCount.toString());

		let $folders:JQuery<HTMLElement> = $(".folderIconWrap");
		$folders.each(function(){
			if (parseInt($(this).attr("id")) == folder) {
				$(this).find(".folder-count").html(folderCount.toString());
				return false;
			};
		});

		$(remCampIconEl).parentsUntil(".row").remove();
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	});
};

export function init_nonFavFolder_dragDrop() {
	$(function(){
		let $allFolderIcons:JQuery<HTMLElement> = $(".folderIconWrap");

		$(".draggable-FolderCampCard").draggable({
			cursor: "grab",
			cursorAt: {top:0},
			opacity: 1,
			helper: function(){return $(mustache.render(campCardPlaceholder,{id:$(this).attr("id")}))},
			scope: "folderDrop"
		});
		$allFolderIcons.each(function(index,element) {
			let id:string = $(this).attr("id");
			$(`#${id}`).droppable({
				accept: ".draggable-FolderCampCard",
				scope: "folderDrop",
				drop: function(event,ui) {
					let camp:number = parseInt($(ui.helper).attr("id"));
					let folder:number = parseInt($(event.target).attr("id"));
					addCampToFolder(camp,folder).then(() => {
						let folderCount:number = parseInt($(event.target).find(".folder-count").html());
						folderCount++;
						$(event.target).find(".folder-count").html(folderCount.toString());
					}).catch(e => {
						const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
						$("#errorModal").modal("show");
					});
				}
			});
		});
	});
};

export function init_favFolder_dragDrop() {
	$(function(){
		$(".favFolderDisp .draggable-favCampCard").draggable({
			cursor: "grab",
			cursorAt: {top:0},
			opacity: 1,
			helper: function(){return $(mustache.render(campCardPlaceholder,{id:$(this).attr("id")}))},
			scope: "folderDrop",
			start: (event,ui) => {},
			snap: ".folder-drop-target",
			snapMode: "inner"
		});
		let $allFolderIcons:JQuery<HTMLElement> = $(".folder-drop-target");
		$allFolderIcons.each(function(index, element) {
			$(this).droppable({
				tolerance: "pointer",
				scope: "folderDrop",
				drop: function(event,ui) {
					let camp:number = parseInt($(ui.helper).find("div.id").attr("id"));
					let folder:number =parseInt($(event.target).attr("folder_id"));

					addCampToFolder(camp,folder).then(() => {
						let folderCount:number = parseInt($(event.target).find(".folder-count").html());
						folderCount++;
						$(event.target).find(".folder-count").html(folderCount.toString());
					}).catch(e => {
						console.error(e);
						if (e.message.includes("Duplicate entry")) {
							alert("Camp is already in folder");
						} else {
							const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
							$("#errorModal").modal("show");
						}
					});
				},

			});
		});
	});
};

export function favorite_campsite(el: HTMLImageElement, camp_id: number) {
	send_favoriteCamp(camp_id).then(() => {
		let $el:JQuery<HTMLElement> = $(`i.favorite-trigger[id=${camp_id}]`);
		$el.removeClass("ai-favoritedHeart");
		$el.removeClass("favorite-trigger")
		$el.addClass("ai-favoritedHeart-filled");
		$el.addClass("unfavorite-trigger");

		$el = $(`a.bookmark.favorite-trigger[id=${camp_id}]`);
		$el.text("Saved");
		$el.removeClass("favorite-trigger");
		$el.addClass("unfavorite-trigger")
		$(`i.unfavorite-trigger[id=${camp_id}]`).each(function() {
			if ($(this).attr("data-bs-original-title") == undefined) {
				$(this).prop("title", "Unsave");
			} else {
				$(this).attr("data-bs-original-title", "Unsave");
			};
			$(this).removeClass("ai-favoritedHeart");
			$(this).addClass("ai-favoritedHeart-filled");
		});
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
	})
};

export function unfavorite_campsite_fromIcon(el: HTMLImageElement, camp_id: number) {
	send_unfavoriteCamp(camp_id).then(() => {
		let $el = $(`i.unfavorite-trigger[id=${camp_id}]`);
		$el.removeClass("ai-favoritedHeart-filled");
		$el.removeClass("unfavorite-trigger")
		$el.addClass("ai-favoritedHeart");
		$el.addClass("favorite-trigger");

		$el = $(`a.bookmark.unfavorite-trigger[id=${camp_id}]`);

		$el.text("Save");
		$(`i.favorite-trigger[id=${camp_id}]`).each(function() {
			if ($(this).attr("data-bs-original-title") == undefined) {
				$(this).prop("title", "Save");
			} else {
				$(this).attr("data-bs-original-title", "Save");
			};
			$(this).removeClass("ai-favoritedHeart-filled");
			$(this).addClass("ai-favoritedHeart");
		});
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
	});
};

export function unfavorite_campsite_remDisp(el: HTMLElement) {
    let campID:number =  parseInt($(el).attr("id"));

	send_unfavoriteCamp(campID).then(() => {
		$(el).parent().parent().parent().remove();
		let numFavs: number = parseInt($("#numFavsDisp").html());
		numFavs--;
		$("#numFavsDisp").html(numFavs.toString());
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	})
};

export function createFolder_favoritesPage(event:JQuery.SubmitEvent) {
	event.preventDefault();
	let name:string = $("#folderName").val() as string;
	createFolder(name).then(data => {
		$("#folderName").val("");
		$(mustache.render(folderIconTemplate,data)).insertBefore("#createFolderBut")
		init_favFolder_dragDrop();
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	});
};

export function deleteFolder_favoritesPage(folderEl:JQuery<HTMLElement>,folderID:number) {
	deleteFolder(folderID).then(() => {
		folderEl.remove();
		$("#favoritesFolderButt").click();
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	});
};

export function expandFolder(folderButEl:HTMLElement, event:JQuery.ClickEvent) {

	let folderID:number = parseInt($(folderButEl).attr("folder_id"));
	getCampsInFolder(folderID).then(function(data) {
		$(".folderIconWrap").each(function(index,element) {
			$(element).removeClass("active");
		});
		$("#favoritesFolderButt").removeClass("active");
		$(folderButEl).addClass("active");
		$("#FavoritesCampList").hide();
		$("#FolderCampList").html(data);
		$("#FolderCampList").show();
		init_nonFavFolder_dragDrop();
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	});
};

export function showFavoritesFolder() {
	$("#FavoritesCampList").show();
	$("#FolderCampList").hide();
	$("#favoritesFolderButt").addClass("active");
	$(".folderIconWrap").each(function(index,element) {
		$(element).removeClass("active");
	});
};
